export class MoneyUtils {
  private static CENTS_IN_DOLLAR = 100;

  /* ----------------------------------
   * CONVERSION
   * ---------------------------------- */

  static dollarsToCents(amount: string | number): number {
    if (amount === undefined || amount === null || amount === "") return amount as number;
    return Math.round(Number(amount) * this.CENTS_IN_DOLLAR);
  }
  // Convert cents to dollar number
  static centsToDollars(cents: number | string): number {
    if (cents === undefined || cents === null || cents === "") return cents as number;
    return Number(cents) / this.CENTS_IN_DOLLAR;
  }

  // Format for display
  static format(cents: number, locale = "en-US", currency = "AUD"): string {
    if (cents === undefined || cents === null || !Number.isFinite(cents)) {
      return "—"
    }

    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      currencyDisplay: "narrowSymbol",
    }).format(this.centsToDollars(cents));
  }

  /* ----------------------------------
   * ARITHMETIC
   * ---------------------------------- */

  static add(...amounts: number[]): number {
    return amounts.reduce((sum, val) => sum + val, 0);
  }

  static subtract(cents1: number, cents2: number): number {
    return Math.round(cents1 - cents2);
  }

  static multiply(cents: number, factor: number): number {
    return Math.round(cents * factor);
  }

  static divide(cents: number, divisor: number): number {
    if (divisor === 0) return 0;
    return Math.floor(cents / divisor);
  }

  static round(cents: number): number {
    return Math.round(cents);
  }

  /**
   * Generic proportional split for multiple components
   * @param totalCents - total amount in cents to split
   * @param componentPrices - array of component weights/prices in cents
   * @returns array of proportional shares in cents
   */
  static splitProportional(totalCents: number, componentPrices: number[]): number[] {
    const sumPrices = componentPrices.reduce((a, b) => a + b, 0);
    if (sumPrices === 0) {
      return componentPrices.map(() => 0);
    }

    const result: number[] = [];
    let assigned = 0;

    for (let i = 0; i < componentPrices.length; i++) {
      const value = Math.round((componentPrices[i] * totalCents) / sumPrices);
      result.push(value);
      assigned += value;
    }

    // assign remainder cents to last component
    const remainder = totalCents - assigned;
    result[result.length - 1] += remainder;

    return result;
  }
}
